<template lang="pug">
div
  chart(
    v-bind="$attrs"
    v-on="$listeners"
    :type="type",
    :params="params",
    :options="options",
    :benchmark-options="benchmarkOptions",
    :extrapolate-enabled='extrapolate',
    :benchmark-open="benchmarkOpen || false",
    :benchmark-enabled="benchmarkEnabled",
    :public="public",
    :height="650"
  )
</template>

<script>
import Config from "next_report/config"
import Chart from "../Chart.vue"

import baseChart from './barChart'

const tooltipFooters = {
  "bar:all/behavior": [
    "js.feedback.behavior.options_small",
    "js.feedback.behavior.options_description",
  ],
  "bar:all/media": [
    "js.feedback.media.options_small",
    "js.feedback.media.options",
  ],
  "bar:all/actors": [
    "js.feedback.actors.options_small",
    "js.feedback.actors.options",
  ],
  "bar:all/actors_coarse": [
    "js.feedback.actors_coarse.options_small",
    "js.feedback.actors_coarse.options_description",
  ],
}

export default {
  components: { Chart },
  props: [
    "type",
    "benchmarkOpen",
    "benchmarkEnabled",
    "color",
    "callback",
    "params",
    "labels_disenable",
    "extrapolate",
    "all",
    "public",
  ],
  computed: {
    tooltips() {
      if (tooltipFooters[this.type]) {
        const [t1, t2] = tooltipFooters[this.type]
        const keys = this.$t(t1)
        const values = this.$t(t2)
        const tt = {}
        for (let key in keys) {
          tt[keys[key]] = values[key]
        }
        return tt
      }
      return {}
    },
  },
  methods: {
    benchmarkOptions(response) {
      if (this.callback) {
        this.callback(response)
      }
      let title

      const sum = Object.values(response.data)
        .map((el) => el.count)
        .reduce((a, b) => a + b, 0)
      const benchmark_sum = Object.values(response.benchmark_data)
        .map((el) => el.count)
        .reduce((a, b) => a + b, 0)

      if (sum == 0 && benchmark_sum == 0) {
        title = "Keine Daten"
      }
      const { all } = this
      const json = baseChart(
        this.categories(response.data),
        [
          {
            name: "Eigene",
            data: Object.keys(response.data)
              .filter((k) => all || response.data[k].count != 0)
              .map((el) => response.data[el].percent),
            color: this.color || Config.colors.own[0],
          },
          {
            name: "Community",
            data: Object.keys(response.data)
              .filter((k) => all || response.data[k].count != 0)
              .map((el) => response.benchmark_data[el].percent),
            color: Config.colors.community[0],
          },
        ],
        true,
        title,
        this.labels_disenable,
        this.tooltips
      )
      return json
    },
    categories(data) {
      const { all } = this
      return Object.keys(data).filter((k) => all || data[k].count != 0)
    },
    extrapolateValue(value) {
      if (this.$store.getters.returnRate > 0) {
        const val = Math.round(value * (100 / this.$store.getters.returnRate))
        return val
      } else {
        return value
      }
    },
    options(response, extrapolate = false) {
      const { all } = this
      if (this.callback) {
        this.callback(response)
      }
      let title

      const sum = Object.values(response.data)
        .map((el) => el.count)
        .reduce((a, b) => a + b, 0)
      if (sum == 0) {
        title = "Keine Daten"
      }

      const extrapolateValue = this.extrapolateValue

      return baseChart(
        this.categories(response.data),
        [
          {
            color: this.color || Config.colors.own[0],
            name: "Eigene",
            data: Object.keys(response.data)
              .filter((k) => all || response.data[k].count != 0)
              .map((el) => extrapolate ? extrapolateValue(response.data[el].count) : response.data[el].count),
          },
        ],
        false,
        title,
        this.labels_disenable,
        this.tooltips
      )
    },
  },
}
</script>

<style>
.highcharts-tooltip > span {
  background: white;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 10px;
  display: block;
  padding: 10px;
  border: 1px solid #eee;
  box-shadow: 0 0 5px #555;
}
.highcharts-tooltip .tip td {
  padding-left: 10px;
}
table.tip caption {
  color: black;
}
.highcharts-tooltip span {
  z-index: 9999 !important;
}
.matrix-bar-chart-wrapper .highcharts-container {
  position: inherit !important;
}
</style>
